import makeMutation from "@saleor/hooks/makeMutation";
import gql from "graphql-tag";

import {
  CurrencyrateApplyRate,
  CurrencyrateApplyRateVariables
} from "./types/CurrencyrateApplyRate";
import {
  CurrencyrateBulkDelete,
  CurrencyrateBulkDeleteVariables
} from "./types/CurrencyrateBulkDelete";
import {
  CurrencyrateCreate,
  CurrencyrateCreateVariables
} from "./types/CurrencyrateCreate";
import {
  CurrencyrateDelete,
  CurrencyrateDeleteVariables
} from "./types/CurrencyrateDelete";
import {
  CurrencyrateUpdate,
  CurrencyrateUpdateVariables
} from "./types/CurrencyrateUpdate";

const currencyrateBulkDelete = gql`
  mutation CurrencyrateBulkDelete($ids: [ID!]!) {
    currencyrateBulkDelete(ids: $ids) {
      errors: errors {
        message
      }
    }
  }
`;
export const useCurrencyrateBulkDeleteMutation = makeMutation<
  CurrencyrateBulkDelete,
  CurrencyrateBulkDeleteVariables
>(currencyrateBulkDelete);

const currencyrateCreate = gql`
  mutation CurrencyrateCreate($input: CurrencyrateCreateInput!) {
    currencyrateCreate(input: $input) {
      currencyrate {
        id
      }
      errors: currencyrateErrors {
        field
        code
      }
    }
  }
`;

export const useCurrencyrateCreateMutation = makeMutation<
  CurrencyrateCreate,
  CurrencyrateCreateVariables
>(currencyrateCreate);

const currencyrateDelete = gql`
  mutation CurrencyrateDelete($id: ID!) {
    currencyrateDelete(id: $id) {
      errors: errors {
        message
      }
    }
  }
`;

export const useCurrencyrateDeleteMutation = makeMutation<
  CurrencyrateDelete,
  CurrencyrateDeleteVariables
>(currencyrateDelete);

const currencyrateUpdate = gql`
  mutation CurrencyrateUpdate($id: ID!, $input: CurrencyrateUpdateInput!) {
    currencyrateUpdate(id: $id, input: $input) {
      errors: currencyrateErrors {
        field
        code
      }
    }
  }
`;

export const useCurrencyrateUpdateMutation = makeMutation<
  CurrencyrateUpdate,
  CurrencyrateUpdateVariables
>(currencyrateUpdate);

const currencyrateApplyRate = gql`
  mutation CurrencyrateApplyRate($id: ID!) {
    currencyrateApplyRate(id: $id) {
      errors {
        message
      }
    }
  }
`;
export const useCurrencyrateApplyRateMutation = makeMutation<
  CurrencyrateApplyRate,
  CurrencyrateApplyRateVariables
>(currencyrateApplyRate);
